"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    KeyValueClient: Symbol("KeyValueClient"),
    KeyValueRoute: Symbol("KeyValueRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.KeyValueRoute).to(_1.KeyValueRoute);
    bind(TYPES.KeyValueClient).to(_1.KeyValueClient);
});
exports.diModule = diModule;
